import(/* webpackMode: "eager", webpackExports: ["ProvidersWrapper"] */ "/vercel/path0/src/providers/ProvidersWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
